import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { confirmAlert } from '../../../../services/mini/alanConfirmAlert';
import billingStatusHelper from '../../../../services/mini/billingStatusHelper';
import device from '../../../../services/mini/device';
import store from '../../../../store';
import Money from '../../../components/Money/Money';
import AddFundsPopup from '../BillingPopups/AddFundsPopup';
import BillingTileHeader from '../BillingTileHeader/BillingTileHeader';
import BillingButton from '../BillingButton/BillingButton';
import * as analyticsActions from '../../../../redux/analytics/actions.analytics';
import { pages, actions as planActions } from '../../../../const/plansAnalytics';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import ApplyPromoCodePopup from '../BillingPopups/ApplyPromoCodePopup';
import { isAnyPaymentAvailable } from '../../../../utils/env/billingEnv';

function BillingPageBalanceInfo({
    plan,
    balance,
    freeInteractions,
    billingStatus,
    trackPlanAction,
    features,
    memberOf,
}) {
    const { caseName } = billingStatusHelper(billingStatus, memberOf);
    const addFundsCb = useCallback(() => {
        trackPlanAction({ page: pages.billing, action: planActions.addFunds });
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <AddFundsPopup
                        onClose={onClose}
                        store={store}
                    />
                );
            }
        });
    }, [trackPlanAction]);
    const applyPromoCodeCb = useCallback(() => {
        trackPlanAction({ page: pages.billing, action: planActions.addFunds });
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <ApplyPromoCodePopup
                        title=""
                        onClose={onClose}
                        store={store} />
                );
            }
        });
    }, [trackPlanAction]);
    const isDesktop = device.isDesktop();
    const isPaymentAvailable = isAnyPaymentAvailable(features);
    return <div className="billing-page-balance-info">
        <BillingTileHeader>
            Balance
            {caseName === 'warning' && <span className="billing-page-balance-info_title-postfix warning">Low Funds</span>}
            {caseName === 'error' && <span className="billing-page-balance-info_title-postfix error">Out of interactions</span>}
        </BillingTileHeader>
        <div className="billing-page-balance-info_content">
            <div className="billing-page-balance-info_amount"><Money amount={balance} /></div>
        </div>
        <div className={`billing-page-balance-info_interactions ${caseName} ${!isDesktop && 'mobile'}`}>
            <span>Interactions</span>
            <b>{freeInteractions}</b>
        </div>
        <div>
            {((isDesktop && !plan.isPeriodic) && isPaymentAvailable) && <BillingButton title="Add Funds" onClick={addFundsCb} className="billing-page-balance-info_add-funds-link" mode={'blue'} />}
            {isDesktop && <BillingButton title="Apply Promo Code" onClick={applyPromoCodeCb} className="billing-page-balance-info_apply-promo-link" />}
        </div>
        {((!isDesktop && !plan.isPeriodic) && isPaymentAvailable) && <BillingButton title="Add Funds" onClick={addFundsCb} className="billing-page-balance-info_add-funds-link" />}
        {!isDesktop && <BillingButton title="Apply Promo Code" onClick={applyPromoCodeCb} className="billing-page-balance-info_apply-promo-link" />}
        <br />
        <br />
        <br />
    </div>;
}

function mapStateToProps({ user, config }, ownProps) {
    return {
        features: config?.features,
        memberOf: user.memberOf,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        trackPlanAction: (param) => asyncDispatch(analyticsActions.trackPlanAction, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BillingPageBalanceInfo);
